import { createRouter, createWebHistory } from 'vue-router';
import Home from '../pages/Home.vue';
import Swap from '../pages/Swap.vue';
import Docs from '../pages/Docs.vue';
import Admin from '../pages/Admin.vue';
import Wallet from '../pages/Wallet.vue';

export default createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: Home },
    { path: '/swap', component: Swap },
    { path: '/docs/:slug?', component: Docs },
    { path: '/admin', component: Admin },
    { path: '/wallet', component: Wallet }
  ]
});
